import { render, staticRenderFns } from "./MyMenusWeek.vue?vue&type=template&id=ccf7ec88&scoped=true"
import script from "./MyMenusWeek.vue?vue&type=script&lang=js"
export * from "./MyMenusWeek.vue?vue&type=script&lang=js"
import style0 from "./MyMenusWeek.vue?vue&type=style&index=0&id=ccf7ec88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf7ec88",
  null
  
)

export default component.exports